import { MuiF } from '../../../../../../../Mui/F/Function/module/MuiF.js';

export const handleHeaderBackButtonClick =
  ({ tab_el }) =>
  () => {
    tab_el.__mp_grid_sticker_editor?.abortCopy?.();
    MuiF.closeFrame(true);
  };
